export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/template/copywriting/log/query`,
          data
        });
      },
      /**
       * 删除版本
       * @param data
       * @return {*}
       */
      removeOperationLog(data) {
          return http.json({
              url: `/operationLog/deleteByIdOperationLog?id=${data[0].id}`,
              data
          })
      },
      list (data){
          return http.json({
              url: '/operationLog/list',
              data
          })
      },
      exportList (data){
          return http.json({
              url: '/template/copywriting/log/list',
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/butlerLog.js